import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import "styles/components/DropDownButtons.scss"; // Import the styles

const DropDownButtons = ({
  handleClick,
  totalElements,
  createdByMeFlag,
  moduleCountSummary,
  isFiltersApplied,
  showCustomList = false,
  customOptions = [],
  customPlaceholder = "",
  dropDownlistName = "",
}) => {
  const [activeButton, setActiveButton] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedElementName, setSelectedElementName] = useState("");

  const handleButtonClick = (buttonIndex) => {
    setActiveButton(buttonIndex);

    if (showCustomList && customOptions[buttonIndex - 1]) {
      const selectedElement = customOptions[buttonIndex - 1];
      setSelectedElementName(selectedElement);
      handleClick(buttonIndex, selectedElement);
    } else {
      handleClick(buttonIndex);
    }

    setDropdownOpen(false);
  };

  const toggleDropdown = (isOpen) => {
    setDropdownOpen(isOpen);
  };
const scrollBarstyles={ maxHeight: '18rem',marginRight:"2px", marginLeft:"2px",overflowY: 'auto',marginTop:'9px' }
  useEffect(() => {
    if (showCustomList) {
      setActiveButton(null);
      setSelectedElementName("");
    } else {
      if (createdByMeFlag) {
        setActiveButton(1);
      } else if (createdByMeFlag === false) {
        setActiveButton(2);
      } else {
        setActiveButton(3);
      }
    }
  }, [createdByMeFlag, showCustomList, customOptions]);

  const getSelectedName = () => {
    if (showCustomList) {
      // Show selected element name if available, otherwise show placeholder
      return `${selectedElementName}` || customPlaceholder;
    }

    let selectedOption = "";
    if (activeButton === 1) {
      let count = !isFiltersApplied
        ? moduleCountSummary?.createdByMe
          ? moduleCountSummary?.createdByMe
          : "0"
        : totalElements
        ? totalElements
        : "0";
      selectedOption = `Created by Me (${count})`;
    } else if (activeButton === 2) {
      let othersCount = !isFiltersApplied
        ? moduleCountSummary?.createdByOthers
          ? moduleCountSummary?.createdByOthers
          : "0"
        : totalElements
        ? totalElements
        : "0";
      selectedOption = `Created by Others (${othersCount})`;
    } else {
      let allCount = !isFiltersApplied
        ? moduleCountSummary?.totalCount
          ? moduleCountSummary?.totalCount
          : "0"
        : totalElements
        ? totalElements
        : "0";
      selectedOption = `All (${allCount})`;
    }
    return selectedOption;
  };

  // Render custom dropdown menu
  const renderCustomMenu = () => (
    <Dropdown.Menu >
       
     <div className="customScrollBar" style={scrollBarstyles}>

    
      {customOptions.map((option, index) => (
        <Dropdown.Item
          key={index}
          onClick={() => handleButtonClick(index + 1)}
          as="button"
          className={`btnLink ${
            activeButton === index + 1 ? "activeButton" : ""
          }`}
          style={{
            borderRadius:
              index === 0
                ? "12px 12px 0 0"
                : index === customOptions.length - 1
                ? "0 0 12px 12px"
                : "0",
            borderBottom:
              index < customOptions.length - 1 ? "1px solid #eee" : "none",
          }}
        >
          <span>{option}</span>
        </Dropdown.Item>
      ))}
        </div>
    </Dropdown.Menu>
  );

  // Original dropdown menu unchanged
  const renderOriginalMenu = () => (
    <Dropdown.Menu>
      <Dropdown.Item
        onClick={() => handleButtonClick(1)}
        as="button"
        className={`btnLink ${activeButton === 1 ? "activeButton" : ""}`}
        style={{
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
        }}
      >
        <span>
          Created by Me{" "}
          {activeButton === 1 || !isFiltersApplied
            ? ` (${
                !isFiltersApplied
                  ? moduleCountSummary?.createdByMe
                    ? moduleCountSummary?.createdByMe
                    : "0"
                  : totalElements
                  ? totalElements
                  : "0"
              })`
            : ""}
        </span>
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => handleButtonClick(2)}
        as="button"
        className={`btnLink ${activeButton === 2 ? "activeButton" : ""}`}
      >
        <span>
          Created by Others{" "}
          {activeButton === 2 || !isFiltersApplied
            ? ` (${
                !isFiltersApplied
                  ? moduleCountSummary?.createdByOthers
                    ? moduleCountSummary?.createdByOthers
                    : "0"
                  : totalElements
                  ? totalElements
                  : "0"
              })`
            : ""}
        </span>
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => handleButtonClick(3)}
        as="button"
        className={`btnLink ${activeButton === 3 ? "activeButton" : ""}`}
        style={{
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "12px",
        }}
      >
        <span>
          All{" "}
          {activeButton === 3 || !isFiltersApplied
            ? `(${
                !isFiltersApplied
                  ? moduleCountSummary?.totalCount
                    ? moduleCountSummary?.totalCount
                    : "0"
                  : totalElements
                  ? totalElements
                  : "0"
              })`
            : ""}
        </span>
      </Dropdown.Item>
    </Dropdown.Menu>
  );

  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={toggleDropdown}
      className={`dropdown-button ${showCustomList ? "topic-list" : ""}`}
    >
      <Dropdown.Toggle
        className={selectedElementName ? "has-selection" : ""}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        {showCustomList ? (
          <span>
            {" "}
            {selectedElementName ? `${dropDownlistName}:` : dropDownlistName}
            <span>{getSelectedName()}</span>{" "}
          </span>
        ) : null}
        {!showCustomList && getSelectedName()}
      </Dropdown.Toggle>

      {showCustomList ? renderCustomMenu() : renderOriginalMenu()}
    </Dropdown>
  );
};

export default DropDownButtons;
